import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Col, Row } from "../common/components/Grid";
import { usePublicGroup } from "../reducers/publicGroupSlice";
import { usePublicNavBar } from "./NavBar";

const PublicFormGroupImpl = ({ hideNav: hideNavInput, code }) => {
    const navBar = usePublicNavBar();
    const group = usePublicGroup(code);
    const hideNav = hideNavInput ?? navBar?.hideNav;

    useEffect(() => navBar?.setTitle(group?.title), [navBar, group?.title]);

    return <div style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '500px' }}>
        { hideNav && <Row className="my-3 text-white">
            <Col>
                <h4>{group?.title}</h4>
            </Col>
        </Row>}
        { group?.forms?.map(form => <Row key={form.code} className="my-3">
            <Col>
                <Link to={`/publicform/${form.code}`} style={{ color: 'white', fontSize: 'large' }}>{form.name}</Link>
            </Col>
        </Row>)}
    </div>
}

export const AngularPublicFormGroup = ({ code }) => <PublicFormGroupImpl hideNav={true} code={code}></PublicFormGroupImpl>;

export const PublicFormGroup = () => {
    const { code } = useParams();
    return <PublicFormGroupImpl code={code}></PublicFormGroupImpl>
}